(function () {
  const initSlider = () => {
    const sliders = document.querySelectorAll('.product-card-js');

    sliders.forEach((slider, index) => {
      const productSlider = new Swiper(slider, {
        scrollbar: {
          el: '.product-scrollbar .swiper-scrollbar',
          clickable: true,
        },
        on: {
          click: () => {
            slider.querySelector('.card-wrapper__link--overlay')?.click();
          },
        },
        navigation: {
          nextEl: '.product-button-group .swiper-button-next',
          prevEl: '.product-button-group .swiper-button-prev',
        },
        allowTouchMove: true,
        990: {
          allowTouchMove: false,
          on: {
            click: () => {},
          },
        },
      });
    });
  };

  initSlider();

  document.addEventListener('shopify:section:load', function () {
    initSlider();
  });
})();
